// extracted by mini-css-extract-plugin
export var active = "_vc-1";
export var circle = "_vc-0";
export var completed = "_vc-2";
export var connector = "_vc-4";
export var connectorCompleted = "_vc-7";
export var connectorSpacer = "_vc-5";
export var iconStrokeOverride = "_vc-8";
export var labelContainer = "_vc-6";
export var pending = "_vc-3";